/**
 * A drop's gateway on the Day timeline: the route's short name (no "(SMPP)"
 * tag or country suffix — the tooltip keeps the full name and lane), "?" for
 * a RANDOM stand-in, "↪" when it was moved (moved out of TimelineRow).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Tooltip } from '@/components/ui';

import type { DayPlanDropRow } from '../../../drop-generator.types';

/** The route's short name — no "(SMPP)" tag, no country suffix. */
export const routeLabel = (name: string | null) =>
  name
    ?.replace(/^\([^)]*\)\s*/, '')
    .replace(/\s*\([^)]*\)\s*$/, '')
    .trim() || null;

export const GatewayCell: FC<{ drop: DayPlanDropRow }> = ({ drop }) => {
  if (drop.routeId === null) return <span className="text-xs text-muted-foreground">—</span>;
  const tip = `${drop.laneLabel ?? drop.routeName ?? `route ${drop.routeId}`}${drop.routeIndicative ? ' — indicative: RANDOM draws at generation' : ''}${drop.routeNote ? ` — ${drop.routeNote}` : ''}`;
  return (
    <span className="min-w-0 text-xs">
      <Tooltip content={tip}>
        <span className={drop.routeNote ? 'block truncate text-warning' : 'block truncate'}>
          {drop.routeNote ? '↪ ' : ''}
          {routeLabel(drop.routeName) ?? `#${drop.routeId}`}
          {drop.routeIndicative ? ' ?' : ''}
        </span>
      </Tooltip>
    </span>
  );
};
